<style lang="scss" scoped>
    .top-menu {
        border-radius: 0px;
        padding: 0px 10px;
        margin-bottom: 0;
        background: #ffffff;
        color: #595E63;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        border: none;
        z-index: 1035;

        &.side-menu-open {
            z-index: 1040;
        }

        .navbar-header {
            display: flex;
            align-items: center;
            justify-content: space-around;

            &.side-on {
                float: none !important;
            }
        }

        .navbar-brand {
            display: flex;
            align-items: center;
            padding: 10px 5px;
            margin: 0;
            flex: 2;
            justify-content: center;

            img {
                width: auto;
                height: 100%;
            }
        }
        .navbar-nav > li > a {
            padding: 6px 15px;
            margin: 9px 0;
        }
        .menu-item {
            font-size: 13px;
            &.active > a {
                color: #FF5B94;
                background: transparent;
                &:hover, &:focus {
                    background: transparent;
                }
            }
        }

        .navbar-right {
           margin-right: 0 !important;
        }

        .navbar-right > li {
            height: 50px;
            .dropdown-toggle::after {
                display: none;
            }
        }
        .navbar-nav > .open, .navbar-nav > li, .nav > .open, .nav > li {
            a, a:hover, a:focus {
                background: transparent;
            }
        }

        .desktop-navbar-right > li {
            height: 50px;
            border-left: 1px solid #e6e6e6;
            padding: 0 5px;
            & > a {
                text-align: center;
                color: #595E63;
            }
            svg {
                font-size: 13px;
            }
            span {
                font-size: 12px;
            }

            &.login-menu-item {
                display: flex;
                align-items: center;
            }
            &.email-subscription-link{
                display: flex;
                align-items: center;
            }
        }

        .navbar-toggle {
            order: -1;
            flex: 1;
            border: none;
            text-align: left;
            font-size: 20px;
            margin: 0;
            min-width: auto;
            z-index: 1055;
            display: block !important;

            button {
                left: -20px;
                position: relative;
                width: 35px;
                height: 30px;
                border: none;
                background: transparent;
                transform: translateX(10px);
                transition: ease all .2s;
            }

            button.open {
                transform: translateX(0);
            }
        }
        .mobile-nav-right {
            flex: 1;
            min-width: 30%;
            .navbar-right {
                display: flex;
                justify-content: flex-end;
                & > li > a {
                    padding: 15px 8px;
                    svg {
                        font-size: 18px;
                    }
                }
                .user-menu-button {
                padding-top: 10px;
                padding-bottom: 10px;
                img {
                    border-radius: 50%;
                    width: 30px;
                    }
                }
            }
        }

        .navbar-left {
            float: left !important;
            margin: 0;
            word-break: break-all;
        }

        .cart-button, .cart-button-mobile {
            .badge {
                position: absolute;
                background-color: #00D38A;
                width: 15px;
                padding: 3px 0;
                font-size: 9px;
            }
        }

        .cart-button {
            position: relative;
            .badge {
                left: 7px;
                top: 2px;
            }
        }

        .cart-button-mobile {
            .badge {
                right: 0;
                top: 6px;
            }
        }
    }
    .menu-shadow {
        box-shadow: 0 1px 19px rgba(0, 0, 0, 0.18);
    }
    .menu-minimised {
        position: absolute;
        left: 100%;
        transform: translateX(-100%);
        min-width: 100%;

    }
    .menu-hide-button-borders {
        &  > li {
            border-color: transparent !important;
        }
    }
    .minimized-navbar-brand {
        position: relative;
        z-index: 5;
        left: 50%;
        transform: translateX(-50%) !important;
    }

    .sideMenu {
        position: fixed;
        height: 100vh;
        top: 0;
        left: 0;
        width: 40%;
        transition: all .3s;
        transform: translateX(-100%);
        padding: 100px 50px;
        overflow-y: auto;

        .menu-item {
            float: none;
        }

        @media screen and (max-width: 500px) {
            width: 90%;
        }
    }

    .slide-in {
        transform: translateX(0);
    }

    .burger-nav-icon {
        cursor: pointer;
        position: relative;
        top: -8px;
        transform: rotate(0deg);
        transition: .5s ease-in-out;
        width: 21px;

        span {
            display: block;
            background-color: currentColor;
            position: absolute;
            height: 3px;
            width: 100%;
            border-radius: 9px;
            opacity: 1;
            left: 0;
            transform: rotate(0deg);
            transition: .25s ease-in-out;

            &:nth-child(1) {
                top: 0px;
            }

            &:nth-child(2), &:nth-child(3) {
                top: 7px;
            }

            &:nth-child(4) {
                top: 14px;
            }
        }
    }

    .burger-nav-icon.open {
        span {
            &:nth-child(1) {
                top: 7px;
                width: 0%;
            }

            &:nth-child(2) {
                transform: rotate(45deg);
            }

            &:nth-child(3) {
                transform: rotate(-45deg);
            }

            &:nth-child(4) {
                top: 7px;
                width: 0%;
            }
        }
    }

    .hideMe {
        position: absolute;
        visibility: hidden;
    }

    .cart-popup-side-menu-open {
        right: -8px !important;
    }
</style>

<template>
    <nav id="top-navbar" class="top-menu navbar" :style="$menuBackgroundStyle" :class="{'no-logo': hideLogo, 'menu-shadow': !hideShadow, 'side-menu-open': this.sideMenu}">
        <div class="nav-container" v-click-outside="closeSideMenu">
            <div class="navbar-header" :class="{'side-on': toggleSideMenu}">
                <!-- Branding Image -->
                <router-link :to="{path: '/'}" class="navbar-brand md" :class="{'hideMe': hideLogo,'minimized-navbar-brand': hideMenuItems}">
                    <img id="navbarHeader" :src="config.logo">
                </router-link>

                <!-- burger button -->
                <div class="navbar-toggle collapsed" v-if="!hideMenuItems && toggleSideMenu" :style="$menuItemIconStyle">
                    <button @click="openSideMenu" type="button"  :class="{'open': sideMenu}">
                        <div class="burger-nav-icon" :class="{'open': sideMenu}">
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </button>
                </div>

                <div class="mobile-nav-right" :class="{'visible-xs-inline-block': !toggleSideMenu}">
                    <ul class="nav navbar-right">
                        <li v-click-outside="hideCartPopupMobile">
                            <a @click="openCart()" class="cart-button-mobile">
                                <font-awesome-icon icon="shopping-cart" :style="$menuItemIconStyle"></font-awesome-icon>
                                <span v-if="!cart.isEmpty()" class="badge">{{cart.getCart().length}}</span>
                            </a>
                            <transition name="c-fade-transition">
                                <cart-popup :class="{'cart-popup-side-menu-open': toggleSideMenu}"
                                            v-if="toggleSideMenu && popupActive" :mobile="true"></cart-popup>
                            </transition>
                        </li>
                        <template v-if="!config.allowCustomerLogin || !loggedInUser">
                            <li v-if="config.allowCustomerLogin" @click="collapseMenu()">
                                <a href="#loginModal" class="guest-menu-button" data-toggle="modal" role="button">
                                    <font-awesome-icon icon="user" :style="$menuItemIconStyle"></font-awesome-icon>
                                </a>
                            </li>
                        </template>
                        <template v-else>
                            <li class="dropdown">
                                <a href="#" class="user-menu-button dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false" @click="collapseMenu()">
                                    <img v-if="loggedInUser.avatar" :src="loggedInUser.avatar.files[50]" width="20">
                                    <font-awesome-icon v-else icon="user" :style="$menuItemIconStyle"></font-awesome-icon>
                                </a>

                                <ul class="dropdown-menu dropdown-menu-right" role="menu" :style="$menuBackgroundStyle">
                                    <li>
                                        <router-link :to="{ name: 'order-history' }" :style="$menuItemTextStyle">
                                            Order History
                                        </router-link>
                                    </li>
                                    <li><a href="#" @click="logout()" :style="$menuItemTextStyle">Logout</a></li>
                                </ul>
                            </li>
                        </template>
                    </ul>
                </div>
            </div>

            <div :style="$menuItemBorderColor">
                <!-- Left Side Of Navbar -->
                <ul id="desktopLeftItems" :class="{'hideMe': toggleSideMenu}" class="normal-navbar-left navbar-left nav navbar-nav" v-if="!hideMenuItems">
                    <top-menu-item v-for="item in pagesConfig" :key="item.id" :item="item" @click.native="collapseMenu()"></top-menu-item>
                </ul>

                <!-- Desktop - Right Side Of Navbar -->
                <ul id="desktopRightItems" class="desktop-navbar-right nav navbar-nav navbar-right hidden-xs" :class="{'menu-hide-button-borders': hideButtonBorders, 'hideMe': toggleSideMenu}">
                    <li v-if="showEmailSubscriptionLink" @click="showEmailSubscriptionModal" class="email-subscription-link">
                        <a  data-toggle="modal">
                            <font-awesome-icon :style="$menuItemIconStyle" :icon="['fa', 'envelope']" size="lg"></font-awesome-icon>
                        </a>
                    </li>
                    <li v-if="user.discountsAvailable" :style="$menuItemBorderColor">
                        <a href="#discountsModal" data-toggle="modal">
                            <svg :style="$menuItemIconStyle" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="19" viewBox="0 0 12 19"><defs><path id="b4qqa" d="M1258.94 20a.6.6 0 0 0-.6.6v4.74a.6.6 0 0 0 1.2 0V20.6a.6.6 0 0 0-.6-.59z"/><path id="b4qqb" d="M1260.13 34.85a.6.6 0 1 1 1.18 0 .6.6 0 0 1-1.18 0z"/><path id="b4qqc" d="M1256.56 30.1a.6.6 0 1 1 1.2 0 .6.6 0 0 1-1.2 0z"/><path id="b4qqd" d="M1260.72 36.63a1.78 1.78 0 1 1 0-3.57 1.78 1.78 0 0 1 0 3.57zm-4.75 0a.6.6 0 0 1-.46-.98l5.94-7.12a.6.6 0 0 1 .91.76l-5.94 7.13a.6.6 0 0 1-.45.2zm1.19-8.32a1.78 1.78 0 1 1 0 3.57 1.78 1.78 0 0 1 0-3.57zm4.4-5.93h-.84v2.96a1.78 1.78 0 0 1-3.56 0v-2.96h-.84l-3.32 3.31v12.13c0 .65.53 1.18 1.19 1.18h9.5c.66 0 1.19-.53 1.19-1.18V25.69z"/></defs><g><g transform="translate(-1253 -20)"><g><g><g><use xlink:href="#b4qqa"/></g></g></g><g><g><g><use xlink:href="#b4qqb"/></g></g></g><g><g><g><use xlink:href="#b4qqc"/></g></g></g><g><g><g><use xlink:href="#b4qqd"/></g></g></g></g></g></svg>
                        </a>
                    </li>

                    <li :style="$menuItemBorderColor" v-click-outside="hideCartPopupDesktop">
                        <a class="cart-button" @click="openCart()">
                            <font-awesome-icon icon="shopping-cart" :style="$menuItemIconStyle"></font-awesome-icon> <span :style="$menuItemTextStyle">{{ cart.getTotal() | displayPrice(!cart.isEmpty()) }}</span>
                            <span v-if="!cart.isEmpty()" class="badge">{{cart.getCart().length}}</span>
                        </a>
                        <transition name="c-fade-transition">
                            <cart-popup v-if="!toggleSideMenu && popupActive" :mobile="false"></cart-popup>
                        </transition>
                    </li>

                    <template v-if="config.allowCustomerLogin">
                        <li v-if="loggedInUser" class="dropdown" :style="$menuItemBorderColor">
                            <a href="#" class="user-menu-button dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false">
                                <font-awesome-icon icon="user" :style="$menuItemIconStyle"></font-awesome-icon>
                                 <span class="logged-in-user-name" :style="$menuItemTextStyle">{{loggedInUser.name}}</span> <font-awesome-icon icon="caret-down" size="xs" :style="$menuItemTextStyle"></font-awesome-icon>
                            </a>

                            <ul class="dropdown-menu" role="menu" :style="$menuBackgroundStyle">
                                <li>
                                    <router-link :to="{ name: 'order-history' }" :style="$menuItemTextStyle">
                                        Order History
                                    </router-link>
                                </li>
                                <li><a href="#" @click="logout()" :style="$menuItemTextStyle">Logout</a></li>
                            </ul>
                        </li>

                        <li v-else class="login-menu-item" :style="$menuItemBorderColor">
                            <a data-toggle="modal" href="#loginModal"><font-awesome-icon icon="user" :style="$menuItemIconStyle"></font-awesome-icon></a>
                        </li>
                    </template>
                </ul>
                <!-- End desktop  'menu-minimised': hideMenuItems    - Right Side Of Navbar -->
            </div>

            <div class="sideMenu" :class="{'slide-in': sideMenu}" :style="$menuBackgroundStyle">
                <ul class="normal-navbar-left navbar-left nav navbar-nav" v-if="!hideMenuItems">
                    <top-menu-item v-for="item in pagesConfig" :key="item.id" :item="item" @click.native="collapseMenu()"></top-menu-item>
                </ul>
            </div>
        </div>
    </nav>

</template>

<script>

    import _ from 'lodash';
    import Configure from './../mixins/configure'
    import Login from './../mixins/login.vue'
    import TopMenuItem from './menuitem.vue'
    import CartPopup from './cart/cart-popup.vue'

	export default {
        data () {
            return {
                windowHeight: 0,
                windowWidth: 0,
                toggleSideMenu: false,
                sideMenu: false,
                navbarHeader: 0,
                desktopLeftItems: 0,
                desktopRightItems: 0,
                initPageLoad: true
            }
        },
        components: {
            TopMenuItem, CartPopup
        },
        created() {
            this.windowHeight = window.innerHeight
            this.windowWidth = window.innerWidth
        },
        mounted() {
            this.debouncedCalc = _.debounce(this.calc, 150);

            this.$nextTick(() => {
                this.calc()

                window.addEventListener('resize', () => {
                    this.windowHeight = window.innerHeight
                    this.windowWidth = window.innerWidth
                    this.calc()
                });
            })
        },
        destroy() {
            window.removeEventListener('resize')
        },
        computed: {
            user() {
                return this.$store.state.user
            },
            config() {
                return this.$store.state.currentConfig
            },
            pagesConfig() {
                return this.config.pagesConfig
            },
            loggedInUser() {
                return this.$store.state.loggedInUser
            },
            cart() {
                return this.$store.state.cart
            },
            hideMenuItems() {
                return this.config.stylesConfig.menu.hide_menu_items.value
            },
            hideLogo() {
                return this.config.stylesConfig.menu.hide_logo.value
            },
            hideShadow() {
                return this.config.stylesConfig.menu.hide_shadow.value
            },
            hideButtonBorders() {
                return this.config.stylesConfig.menu.hide_button_borders.value
            },
            minimiseMenu() {
                return this.config.stylesConfig.menu.minimise_menu.value
            },
            mobilePopup() {
                if (this.windowWidth < 768 || this.windowHeight < 550) {
                    return true
                }

                return false
            },
            popupActive() {
                return this.$store.state.cartPopupClicked
            },
            showEmailSubscriptionLink(){
                return ab.config.emailSubscription.enabled && ab.hasMailingList && this.$route.name !== "checkout" && !ab.configure;
            }
        },
        mixins: [Configure, Login],
        methods: {
            showEmailSubscriptionModal(){
                this.$modal.show("email-subscription");
            },
            showCartPopup() {
                this.$store.commit('toggleCartPopupClick', !this.popupActive)
            },
            hideCartPopupDesktop() {
                if(!this.toggleSideMenu) {
                   this.closeCart();
                }
            },
            hideCartPopupMobile() {
                if(this.toggleSideMenu) {
                   this.closeCart();
                }
            },
            closeCart() {
                 if (this.$store.state.userClickedOnBuy) {
                        this.$store.commit('setUserClickedOnBuy', false)
                        return
                    }

                this.$store.commit('toggleCartPopupClick', false)
            },
            collapseMenu() {
                if (this.windowWidth < 768) {
                    this.sideMenu = false;
                }
            },
            getElementsWidth() {
                this.navbarHeader = document.getElementById("navbarHeader").offsetWidth;
                this.desktopLeftItems = document.getElementById("desktopLeftItems").offsetWidth;
                this.desktopRightItems = document.getElementById("desktopRightItems").offsetWidth;
            },
            calc() {
                if(!this.hideMenuItems) {
                    if (this.windowWidth > 768) {
                        // Get nav elements width
                        this.getElementsWidth();
                        // Get window width
                        // let windowWidth = this.windowWidth;

                        // Calculate the sum of widths of the nav elements
                        let val = this.desktopLeftItems + this.desktopRightItems + 50;

                        // Only add logo width if logo is shown
                        if(!this.hideLogo) {
                            val += this.navbarHeader;
                        }

                        // On initial page load add extra space to count for logo as it gets downloaded
                        if(this.initPageLoad) {
                            val += 90;
                            this.initPageLoad = false;
                        }

                        // If totalElements width is bigger than the screen width collapse to side menu
                        if (val >= this.windowWidth) {
                            this.toggleSideMenu = true;
                            return;
                        }

                        // Otherwise hide side menu
                        this.toggleSideMenu = false;
                        this.sideMenu = false;
                        return;
                    }

                    // Show side menu if screen is smaller than 768px
                    this.toggleSideMenu = true;
                    return;
                }
                // If menu items are hiden toggle the side menu off
                this.toggleSideMenu = false;
                this.sideMenu = false;
            },
            openSideMenu() {
                this.sideMenu = !this.sideMenu;
            },
            closeSideMenu() {
                this.sideMenu = false;
            },
            openCart() {
                if(this.windowWidth > 767 && this.windowHeight > 550) {
                    this.$store.commit('toggleCartPopupClick', !this.popupActive)
                    return;
                }

                $('#cartModal').modal('show')
            }
        },
        watch: {
            '$store.state.currentConfig.pagesConfig.length': {
                handler(oldValue, newValue) {
                    this.debouncedCalc();
                },
            },
            $route (to, from){
                this.closeSideMenu();
            },
            '$store.state.nameChange': {
                handler(value) {
                    if (value) {
                        this.debouncedCalc();
                        this.$store.commit('pageNameChanged', false);
                    }
                }
            }
        }
	}
</script>
